import { ROUTES } from "./common/constants/routes";
import { SessionAuthCookies } from "./libs/cookies";
import { registerMiddleware } from "./libs/react-router";

registerMiddleware({
  // Index route handling middleware
  matcher: "^/$",
  handler: () => {
    const hasRefreshToken = Boolean(SessionAuthCookies.getRefreshToken());

    if (hasRefreshToken) {
      return {
        redirect: ROUTES.DASHBOARD,
      };
    } else {
      return {
        redirect: ROUTES.AUTH.LOGIN,
      };
    }
  },
});

registerMiddleware({
  // Match all routes
  matcher: ".*",
  handler: (request) => {
    const url = new URL(request.url);
    const pathname = url.pathname;
    const hasRefreshToken = Boolean(SessionAuthCookies.getRefreshToken());

    const publicRoutes = [ROUTES.AUTH.LOGIN];

    const isPublicRoute = publicRoutes.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`)
    );

    if (!isPublicRoute && !hasRefreshToken) {
      return {
        redirect: `/login?redirect=${encodeURIComponent(pathname)}`,
      };
    }

    if (isPublicRoute && hasRefreshToken) {
      return {
        redirect: "/dashboard",
      };
    }

    return;
  },
});
